import { Component } from '@angular/core';
import {
    CdkDragDrop,
    moveItemInArray,
    transferArrayItem,
} from '@angular/cdk/drag-drop';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { muckpileQuery } from '@models';

@Component({
    selector: 'dialog-change-muckpile-status',
    templateUrl: './dialog-change-muckpile-status.component.html',
    styleUrls: ['./dialog-change-muckpile-status.component.scss'],
})
export class DialogChangeMuckpileStatusComponent {
    public activeMuckpiles: muckpileQuery.list.MuckpileInfo[] = [];
    public inactiveMuckpiles: muckpileQuery.list.MuckpileInfo[] = [];
    public isUpdating: boolean = false;

    constructor(
        public readonly fragQuery: FragQueryService,
    ) {
        this.fragQuery.muckpiles$.subscribe((muckpiles) => {
            const currentMuckpiles = muckpiles ?? [];
            this.activeMuckpiles = currentMuckpiles.filter(m => m.isActive);
            this.inactiveMuckpiles = currentMuckpiles.filter(m => !m.isActive);
        });
    }

    async drop(event: CdkDragDrop<muckpileQuery.list.MuckpileInfo[]>): Promise<void> {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            const movedMuckpile = event.previousContainer.data[event.previousIndex];
            movedMuckpile.isActive = !movedMuckpile.isActive;
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex,
            );
            this.isUpdating = true;
            await this.updateMuckpileStatus(movedMuckpile);
            this.isUpdating = false;
        }
    }

    private async updateMuckpileStatus(muckpile: muckpileQuery.list.MuckpileInfo): Promise<void> {
        try {
            await this.fragQuery.setMuckpileStatus(muckpile.id, muckpile.isActive)
            this.fragQuery.trigger$.next()
        } catch (error) {
            console.error(`Error updating muckpile ${muckpile.name}:`, error);
        }
    }

}
